export default "__VITE_ASSET__C72UnGoa__"